import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SearchPanel from '@libs/components/common/SearchPanel';
import { WELL_TABLE_SEARCH_CONFIG } from '@libs/components/common/SearchPanel/wellSearchModeConfig.js';

import { LOG_MODULES,APP_SETTINGS } from "@config/config";

//import { API_LIST_CONFIGSxx } from '@apps/components/DataViewer/WellDataViewer/wellApiConfig/ApiListConfigxs';
import { log } from '@libs/utils/helper.js';

import './WellFtTablePanel.css';

// --- Configuration Constants ---
const SUPPORT_MULTI_FIELDS = true;
const FILTER_CHECKED_MIN_COUNT = 10; // ← checkbox only enabled above this many checked wells

//console.error("WellFtTablePanel APP_SETTINGS.SearchInitalValues", APP_SETTINGS.SearchInitalValues);
const WELL_SEARCH_INIT_STATES = {
  ...APP_SETTINGS.SearchInitalValues,
  pageSize: 10, // 👈 Overwriting the default pageSize of 5 to 10
  queryParams: {
    ...APP_SETTINGS.SearchInitalValues.queryParams,
    searchMode: "startswith", // Overriding just this specific property
  }
};

/**
 * WellFtTablePanel - Manages the bottom section of the split view.
 * Integrates the Search/Filter UI with the ESRI FeatureTable container.
 */
const WellFtTablePanel = ({
  tableId, onApplyFilter, checkedCount = 0, filterChecked = false,
  onToggleFilterChecked, isCheckedMode = false,
}) => {

  const isCheckboxEnabled = checkedCount > FILTER_CHECKED_MIN_COUNT && !isCheckedMode;

  return (
    <div className="well-arcgis-mapper table-wrapper-container">
      {/* 1. Filter UI Section */}
      <div className="search-section">
        <div
          className={
            isCheckedMode
              ? 'search-section__search search-section__search--disabled'
              : 'search-section__search'
          }
        >
          <SearchPanel
            initial={WELL_SEARCH_INIT_STATES}
            fieldsConfig={WELL_TABLE_SEARCH_CONFIG}
            mergeOnApply={SUPPORT_MULTI_FIELDS}
            onApply={(activeParams) => {
                        //log(LOG_MODULES.WELLSEARCH, "[WellFtTablePanel] Filter applied:", activeParams);
                        if (onApplyFilter) {
                          onApplyFilter(activeParams);
                        }    
                    }}
            logModule={LOG_MODULES.WELLSEARCH}
          />
        </div>

        {isCheckedMode && (
          <span className="checked-mode-hint">
            Search disabled — Checked Mode
          </span>
        )}

        {/* Scope-search-to-selection toggle */}
        <label
          title={
            isCheckedMode
              ? 'Switch to Search Mode to use search options'
              : isCheckboxEnabled
                ? 'Search only within the currently checked wells'
                : `Check more than ${FILTER_CHECKED_MIN_COUNT} wells to enable this option`
          }
          className={
            isCheckboxEnabled
              ? 'filter-checked-toggle'
              : 'filter-checked-toggle filter-checked-toggle--disabled'
          }
        >
          <input
            type="checkbox"
            checked={filterChecked}
            disabled={!isCheckboxEnabled}
            onChange={(e) => onToggleFilterChecked?.(e.target.checked)}
          />
          Filter checked points ({checkedCount})
        </label>
      </div>

      {/* 2. ESRI SDK Widget Target */}
      <div id={tableId} className="table-target" />
    </div>
  );
};

WellFtTablePanel.propTypes = {
  tableId: PropTypes.string.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  checkedCount: PropTypes.number,
  filterChecked: PropTypes.bool,
  onToggleFilterChecked: PropTypes.func,
  isCheckedMode: PropTypes.bool,
};

export default memo(WellFtTablePanel);